import React from 'react';
import PropTypes from 'prop-types';
import ListTitleIsOnBullet from './ListTitleIsOnBullet';
import { Button, Tooltip, message } from 'antd';
import { useTitle } from '../../../Title/containers/TitleDataStore';
import { useCollaborativeList } from '../../containers/CollaborativeListDataStore';
import { Translate } from '@above-the-treeline/localization';
import paths from '../../../../paths';
import { Link } from 'react-router-dom';

ListTitle.propTypes = {
	skus: PropTypes.array,
	community: PropTypes.object,
	list: PropTypes.object,
};

function ListTitle({ skus, list, community }) {
	const titleDataStore = useTitle();
	const collaborativeListDataStore = useCollaborativeList();

	const getListTitleWithDescriptionPopover = list => {
		return (
			<Tooltip title={list.description} placement="right">
				{list.name}
			</Tooltip>
		);
	};

	const addTitleToList = (listId, translate) => {
		if (!skus || skus.length === 1) {
			titleDataStore.addTitles(listId);
		} else {
			const listItems = skus.map(sku => ({
				listId: listId,
				sku: sku,
			}));
			const onSuccess = () =>
				message.success(
					listItems.length > 1
						? translate('the_titles_have_been_added')
						: translate('the_title_has_been_added'),
				);
			collaborativeListDataStore.postTitlesToList(
				listId,
				listItems,
				onSuccess,
			);
		}
	};

	let isOnList = false;

	if (titleDataStore) {
		const { lists } =
			titleDataStore.state && titleDataStore.state.collaborativeLists;
		isOnList = lists && lists.some(li => li.id === list.id);
	}
	return (
		<>
			{isOnList ? (
				<ListTitleIsOnBullet
					list={list}
					communityName={community.name}
				/>
			) : (
				<div className="add-to-list">
					<Translate>
						{translate => (
							<Button
								size="small"
								onClick={() =>
									addTitleToList(list.id, translate)
								}>
								{translate('add')}
							</Button>
						)}
					</Translate>
					<Link
						to={paths.collaborativeList(list.id)}
						className="column-spaced collaborative-list-title">
						{list.description
							? getListTitleWithDescriptionPopover(list)
							: list.name}
					</Link>
					<div className="clear" />
				</div>
			)}
		</>
	);
}

export default ListTitle;
